export const BOARD_SECTIONS = {
    Source: 'Source',
    Target: 'Target',
    // done: 'done',
  };
  